import React, { Component } from 'react';
import { Icon } from 'antd';

class ExportButton extends Component {
  render() {
    return (
      <button className="btn btn-warning d-flex align-items-center justify-content-center" onClick={this.props.handleClick} style={{ width: '40px', height: '40px', position: 'fixed', bottom: '100px', right: '40px', borderRadius: '30px' }}>
        <Icon type="file-excel" style={{ fontSize: '1.2em' }} />
      </button>
    );
  }
}

export default ExportButton;



// WEBPACK FOOTER //
// ./src/components/ExportButton.js